import React from 'react';
import SelectableList from '../common/selectable_list';

const MeetingLayersListItem = (item, handleClick) => {
  return (
    <li className={`abl-border ${item.className}`} onClick={handleClick}>
      {item.name}
    </li>
  );
};

export default function MeetingLayersList(props) {
  return (
    <SelectableList 
      tagName="ul"
      className="abl-layers-list"
      selectedClass={(item) => item.selectedClass}
      items={props.items}
      onChange={props.onChange}
      multiSelect={true}
      itemTemplate={MeetingLayersListItem} />
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/meeting_layers_list.js
 **/